import type { ReactNode } from 'react';

/**
 * Registro (ADR 0128): um item aberto. Em cima, o título, a situação e os botões; no corpo, as
 * abas ou blocos dele; ao lado (ou embaixo, quando o espaço do registro é estreito: no celular, na gaveta, no painel), os dados de bate-olho em `FactList`.
 */
export function RecordLayout({
  title,
  meta,
  actions,
  aside,
  children,
}: {
  title: ReactNode;
  /** Código e situação (ex.: "PED-000123 · Em separação", com `Badge`). */
  meta?: ReactNode;
  actions?: ReactNode;
  /** Dados de bate-olho: responsável, datas, valores. */
  aside?: ReactNode;
  children: ReactNode;
}) {
  return (
    <article className="@container flex min-w-0 flex-col gap-4">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 flex-col gap-1">
          <h2 className="text-lg leading-tight font-semibold tracking-tight">{title}</h2>
          {meta && <div className="flex flex-wrap items-center gap-2 text-sm">{meta}</div>}
        </div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </header>
      <div className={`grid min-w-0 gap-4 ${aside ? '@2xl:grid-cols-[minmax(0,1fr)_16rem]' : ''}`}>
        <div className="flex min-w-0 flex-col gap-4">{children}</div>
        {aside && <aside className="flex min-w-0 flex-col gap-4 @2xl:order-last">{aside}</aside>}
      </div>
    </article>
  );
}

/** Lista de rótulo e valor ("Responsável: Ana"), para o lado do registro ou um painel. */
export function FactList({ items }: { items: { label: ReactNode; value: ReactNode }[] }) {
  return (
    <dl className="ui-panel flex flex-col divide-y divide-rule rounded-lg bg-sheet text-sm">
      {items.map((item, i) => (
        <div key={i} className="flex flex-col gap-0.5 px-4 py-2.5">
          <dt className="text-xs text-muted">{item.label}</dt>
          <dd className="min-w-0 break-words">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
